import { useEffect } from "react";
import "./Home.css";
import scooter from "../../Image/scooty3.png";

import PopupTestDrive from "./PopupTestDrive/PopupTestDrive";
import Achievements from "./Achievements/Achievements";
import WhyChoose from "./WhyChoose/WhyChoose";
import FinancialPartners from "./FinancialPartners/FinancialPartners";
import HeroSection from "./HeroSection/HeroSection";
import Product from "./Product/Product";

import { useTestDrive } from "../../context/TestDriveContext"; // ✅ ADDED

const Home = () => {
  const { showPopup, openPopup, closePopup } = useTestDrive(); // ✅ ADDED

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  }, []);

  return (
    <section>
      <section className="home">
        <div className="green-shape left"></div>
        <div className="green-shape right"></div>

        <div className="home-content">
          <div className="home-text">
            <div className="logo-arc"></div>

            <h1>
              Book Your New <br />
              <span className="Eco-Friendly">Eco-Friendly</span> <br />
              Ride.
            </h1>

            <p>
              Join the green revolution with our premium electric scooters. Zero
              emissions, maximum freedom.
            </p>

            {/* ✅ CHANGED */}
            <button className="book-btn1 zoom-animate" onClick={openPopup}>
              Book Test Drive
            </button>
          </div>

          <div className="home-image">
            <img
              src={scooter}
              alt="Electric Scooter"
              className="zoom-animate"
            />
          </div>

          <div className="features">
            <div className="feature">
              <span>🚗</span>
              <p>
                100%
                <br />
                Electric
              </p>
            </div>

            <div className="feature">
              <span>🔋</span>
              <p>
                UpTo 130 km
                <br />
                Range
              </p>
            </div>

            <div className="feature">
              <span>🌱</span>
              <p>
                Carbon
                <br />
                Neutral
              </p>
            </div>

            <div className="feature">
              <span>⚡</span>
              <p>60km/h</p>
            </div>
          </div>
        </div>
      </section>

      <div className="home_line_border"></div>

      <Product />
      <Achievements />
      <WhyChoose />
      <HeroSection />
      <FinancialPartners />

      {/* ✅ GLOBAL POPUP */}
      {showPopup && <PopupTestDrive onClose={closePopup} />}
    </section>
  );
};

export default Home;
